// header element
const header = document.querySelector("#header");
let isClosingDesktop = false;
let isClosingMobile = false;

// toggle blend mode on load
document.addEventListener("DOMContentLoaded", () => {
    if (window.scrollY > 0) {
        document.querySelector("#shopify-section-theme-header").classList.add("mixBlendMode");
    }
});

// nested dropdown menu
header.querySelectorAll(".menuToggle").forEach(element => {
    element.addEventListener("click", function () {
        // prevents multiple clicks
        if (isClosingDesktop) return;
        // close the dropdown menu
        if (this.classList.contains("active")) {
            closeDropDown();
            return;
        }

        // add active class to menu item
        header.querySelectorAll(".menuToggle").forEach(el => el.classList.add("active"));
        // add active class to header
        header.classList.add("active");

        // add listener to rest of page to close dropdown
        document.addEventListener("click", function (e) {
            if (e.target !== header && !header.contains(e.target)) {
                closeDropDown();
            }
        }, true);

        // hide logo and reveal blended logo
        if (header.classList.contains("active") && header.classList.contains("sticky")) {
            if (!document.querySelector("#shopify-section-theme-header").classList.contains("mixBlendMode")) {
                document.querySelector("#shopify-section-theme-header").classList.add("mixBlendMode");
            }
        }

    });
});

function closeDropDown() {
    isClosingDesktop = true;
    header.querySelectorAll(".menuToggle").forEach(el => el.classList.remove("active"));
    setTimeout(() => {
        header.classList.remove("active");
        if (!header.classList.contains("active")) {
            document.querySelector("#shopify-section-theme-header").classList.remove("mixBlendMode");
        }
        // remove header related classes from body
        document.body.classList.remove("headerOpen");
        isClosingDesktop = false;
    }, 1200);
}

// set the margin bottom of the header
header.parentElement.style.marginBottom = "-" + (header.offsetHeight + 1) + "px";

// update header position
window.addEventListener("scroll", wheresYourHeaderAt);

function wheresYourHeaderAt() {
    if (header.getBoundingClientRect().top <= 1) {
        header.classList.add("sticky");
        document.querySelector("#shopify-section-theme-header").classList.add("mixBlendMode");
        document.body.classList.add("stickyHeader");
    } else {
        header.classList.remove("sticky");
        document.querySelector("#shopify-section-theme-header").classList.remove("mixBlendMode");
        document.body.classList.remove("stickyHeader");
    }
}

// initial check
wheresYourHeaderAt();

// hover display on desktop dropdown menu
header.querySelectorAll(".headerNavItemExpandedLinksItemLink").forEach(link => {
    link.addEventListener("mouseenter", function () {
        header.querySelector(`.headerNavItemExpandedHoverImage[data-product="${this.dataset.product}"]`)?.classList.add("active");
        header.querySelector(`.headerNavItemExpandedHoverTextItem[data-product="${this.dataset.product}"]`)?.classList.add("active");
    })
    link.addEventListener("mouseleave", function () {
        header.querySelector(`.headerNavItemExpandedHoverImage[data-product="${this.dataset.product}"]`)?.classList.remove("active");
        header.querySelector(`.headerNavItemExpandedHoverTextItem[data-product="${this.dataset.product}"]`)?.classList.remove("active");
    })
})

/**************
 Mobile Nav
 ***************/

// to allow dynamic height calculation
const innerHeight = window.innerHeight;

// open nav
header.querySelector("#headerMenu")?.addEventListener("click", function () {
    if (header.querySelector("#sliderContent").classList.contains("close")) return;
    if (!header.classList.contains("active")) {
        header.querySelector("#slider").showModal();
        if (!header.classList.contains("active")) {
            document.querySelector("#shopify-section-theme-header")?.classList.add("mixBlendMode");
        }
        document.querySelector("body").classList.add("noScroll");
        // set parameters for slider
        const top = header.getBoundingClientRect().bottom;
        if (header.querySelector("#sliderContent")) {
            header.querySelector("#sliderContent").style.top = (top - 8) + "px";
            header.querySelector("#sliderContent").style.height = `calc(${innerHeight}px - ${top}px)`;
        }
    }
    header.classList.toggle("active");
});

// close nav
async function closeNav() {
    header.querySelector("#sliderContent")?.classList.add("close");
    header.classList.remove("active");
    // for transition
    setTimeout(() => {
        header.querySelector("#slider")?.close();
        if (!header.classList.contains("active")) {
            document.querySelector("#shopify-section-theme-header")?.classList.remove("mixBlendMode");
        }
        document.querySelector("body").classList.remove("noScroll");
        header.querySelector("#sliderContent")?.classList.remove("close");
        // reset slider position
        if (header.querySelector("#sliderContent")) {
            header.querySelector("#sliderContent").style.top = "100%";
        }
    }, 600);
}

// close nav event listener
document.querySelectorAll(".closeNav")?.forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// dialog close itself
header.querySelector("#slider")?.addEventListener("click", async function (e) {
    if (e.target === this) {
        await closeNav();
    }
});

// dialog close event
header.querySelector("#slider")?.addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// register dialog
if (header.querySelector("#slider")) {
    dialogPolyfill.registerDialog(header.querySelector("#slider"));
}
